
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary/30 py-12 border-t border-border/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <a href="#" className="text-xl font-semibold flex items-center gap-2">
              <span className="text-primary">&lt;</span>
              <span>Aniket Kasale</span>
              <span className="text-primary">/&gt;</span>
            </a>
            <p className="text-muted-foreground mt-2">
              Frontend Engineer building scalable products and intelligent solutions.
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://github.com/aniketkasale"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full border border-border/50 hover:border-primary/50 transition-colors"
            >
              <Github className="w-5 h-5" />
              <span className="sr-only">Github</span>
            </a>
            <a
              href="https://www.linkedin.com/in/aniket-kasale/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full border border-border/50 hover:border-primary/50 transition-colors"
            >
              <Linkedin className="w-5 h-5" />
              <span className="sr-only">LinkedIn</span>
            </a>
            <a
              href="mailto:aniketkasale02@gmail.com"
              className="p-2 rounded-full border border-border/50 hover:border-primary/50 transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span className="sr-only">Email</span>
            </a>
          </div>
        </div>

        <div className="border-t border-border/50 mt-8 pt-8 text-center text-muted-foreground text-sm">
          <p>&copy; {currentYear} Aniket Kasale. All rights reserved.</p>
          <p className="mt-1">
            Frontend Engineer | BE CSE, SPPU | React.js Specialist
          </p>
          <a
            href="https://drive.google.com/file/d/1Jn88Lw-iZnhX-qiaAqKx-14F_M1uYHWI/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-block text-primary hover:underline"
          >
            View Resume
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
